import { render, staticRenderFns } from "./AboutContainer.vue?vue&type=template&id=45e71402&scoped=true&"
import script from "./AboutContainer.vue?vue&type=script&lang=js&"
export * from "./AboutContainer.vue?vue&type=script&lang=js&"
import style0 from "./AboutContainer.vue?vue&type=style&index=0&id=45e71402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e71402",
  null
  
)

export default component.exports